import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Icon, Table, TableBody } from 'semantic-ui-react';
import * as api from '../../../stores/api';
import { Link } from 'react-router-dom';
import { TableEmptyMessage, TableFooterPagination, TableHeader } from '../../shared/table';
import Store from './Store';
import { Dropdown, Menu, notification } from 'antd';
import { deleteItem } from './Service';

const columns = [
  { title: '' },
  { title: 'MBS Code' },
  { title: 'Category' },
  { title: 'Group' },
  { title: 'SubGroup' },
  { title: 'Clinical Indication' },
  { title: 'Additional Notes' },
  { title: 'Scheduled Fee (excl GST)' },
  { title: 'Exclusion Codes' },
  { title: 'Status' },
  { title: 'Published Year' },
];

@observer
class MBSCodeTable extends React.Component {
  openModal = options => {
    return Store.toggleModal(true, options);
  };

  renderExclusionCode = record => {
    if (record.ListExcludedAMACode) {
      return record.ListExcludedAMACode.map(ex => {
        return (
          <label key={'ex-' + ex.Id} className="ui label" style={{ margin: '2px' }}>
            {' '}
            {ex.ExcludedAMACode}
          </label>
        );
      });
    }
    return null;
  };

  renderExclusionCodeRanges = record => {
    if (record.ExcusionCodeRanges && record.ExcusionCodeRanges.length > 0) {
      return record.ExcusionCodeRanges.map(ex => {
        return (
          <label key={'ex-range' + ex.Id} className="ui label" style={{ margin: '2px' }}>
            {' '}
            {ex.ExclusionRange}
          </label>
        );
      });
    }
    return null;
  };

  handleEdit = (id, record) => {
    return Store.toggleModal(true, {
      modalType: 'addOrEdit',
      id,
      record,
    })();
  };

  handleDeleteItem = id => {
    deleteItem(id).then(resp => {
      if (resp.status === 'success') {
        notification.destroy();
        notification.success({
          message: 'Success',
          description: 'Data has been saved successfully.',
          duration: 3,
        });
        Store.refetch({ curPage: 1 });
      } else {
        notification.destroy();
        notification.error({
          message: 'Error',
          description: 'An error occurred, please try again',
          duration: 3,
        });
      }
    });
  };

  renderTableActions = (id, record) => (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu>
          <Menu.Item onClick={() => this.handleEdit(id, record)}>Edit</Menu.Item>
          <Menu.Item
            onClick={this.openModal({
              modalType: 'confirm',
              message: `Do you want to delete this code?`,
              onOk: () => this.handleDeleteItem(id),
            })}
          >
            Delete
          </Menu.Item>
        </Menu>
      }
    >
      <Icon name="ellipsis vertical" />
    </Dropdown>
  );

  renderTableBody = (data, colSpan) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id} negative={record.Status !== 0}>
        <Table.Cell className="Cell-actions">{this.renderTableActions(Id, record)}</Table.Cell>
        <Table.Cell selectable className={cx({ 'Cell-nowrap Cell-link': record.Status === 0 })}>
          {api.isAdmin() ? (
            <Link to="#" onClick={() => this.handleEdit(Id, record)} style={{ color: `#9f3a38` }}>
              {record.MBSCode}
            </Link>
          ) : (
            record.MBSCode
          )}
        </Table.Cell>
        <Table.Cell>{record.Category}</Table.Cell>
        <Table.Cell>{record.Group}</Table.Cell>
        <Table.Cell>{record.SubGroup}</Table.Cell>
        <Table.Cell>{record.ClinicalIndication}</Table.Cell>
        <Table.Cell>{record.AdditionalNotes}</Table.Cell>
        <Table.Cell>${record.Fee === null ? 0 : record.Fee}</Table.Cell>
        <Table.Cell>
          {/* {this.renderExclusionCode(record)}
          {record.ExcusionCodeRanges && record.ExcusionCodeRanges.length > 0
            ? this.renderExclusionCodeRanges(record)
            : ''} */}
        </Table.Cell>
        <Table.Cell>{record.StatusText}</Table.Cell>
        <Table.Cell>{record.PublishedYear}</Table.Cell>
      </Table.Row>
    ));
  };

  handlePageClick = page => {
    Store.refetch({ curPage: page });
  };

  render() {
    const { data, loading, sortColumn, sortDirection } = Store;
    const column = api.isAdmin() ? columns.map(i => i) : columns.filter(i => i.title !== '').map(i => i);
    const colSpan = column.length;
    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader columns={column} sortColumn={sortColumn} sortDirection={sortDirection} onSort={Store.handleSort} />
        <TableBody>{this.renderTableBody(data, colSpan)}</TableBody>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={Store.curPage}
          totalPage={Store.totalPage}
          totalItems={Store.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}

export default MBSCodeTable;
